/**
 * Типы сохранения проекта.
 */
export type { SaveState } from "./hooks/usePlanStorage";
export type { ProjectFile } from "./hooks/serialization";
export type { LocalProject } from "./hooks/localProjectCache";

export enum ProjectSyncState {
	Error,
	Loading,
	Offline,
	Ready,
}
